/* =====================================================
   GreenChef 2026 Category Section
   File: assets/gc-2026-category-section.js
===================================================== */

(function () {

  /* =====================================================
     Find active category carousel
  ===================================================== */

  function getActiveCategoryScroller(section) {

    return (
      section.querySelector(
        '.gc-commerce-category-grid.is-active[data-gc-category-scroll]'
      ) ||

      section.querySelector(
        '.gc-commerce-category-grid:not([hidden])[data-gc-category-scroll]'
      ) ||

      section.querySelector(
        '.gc-commerce-category-grid[data-gc-category-scroll]'
      )
    );

  }


  /* =====================================================
     Carousel scrolling
  ===================================================== */

  function scrollCategory(
    section,
    direction
  ) {

    var scroller =
      getActiveCategoryScroller(
        section
      );


    if (!scroller) {
      return;
    }


    var firstCard =
      scroller.querySelector(
        '.gc-commerce-category-card'
      );


    var cardWidth =
      firstCard
        ? firstCard
            .getBoundingClientRect()
            .width
        : 260;


    var styles =
      window.getComputedStyle(
        scroller
      );


    var gap =
      parseFloat(
        styles.columnGap ||
        styles.gap ||
        14
      ) || 14;


    var amount =
      Math.max(
        cardWidth + gap,
        scroller.clientWidth * 0.78
      );


    scroller.scrollBy({
      left:
        direction * amount,

      behavior:
        'smooth'
    });

  }


  /* =====================================================
     Category tabs
  ===================================================== */

  function activateCategoryTab(
    section,
    target
  ) {

    var tabs =
      section.querySelectorAll(
        '[data-gc-category-tab]'
      );


    var panels =
      section.querySelectorAll(
        '.gc-commerce-category-grid[data-gc-category-panel]'
      );


    tabs.forEach(function (tab) {

      var active =
        tab.getAttribute(
          'data-gc-category-tab'
        ) === target;


      tab.classList.toggle(
        'is-active',
        active
      );


      tab.setAttribute(
        'aria-selected',
        active
          ? 'true'
          : 'false'
      );

    });


    panels.forEach(
      function (panel) {

        var active =
          panel.getAttribute(
            'data-gc-category-panel'
          ) === target;


        panel.classList.toggle(
          'is-active',
          active
        );


        if (active) {

          panel.removeAttribute(
            'hidden'
          );


          panel.scrollLeft = 0;

        } else {

          panel.setAttribute(
            'hidden',
            ''
          );

        }

      }
    );

  }


  /* =====================================================
     Bind category tabs
  ===================================================== */

  function bindGreenChefCategoryTabs() {

    document
      .querySelectorAll(
        '.greenchef-commerce-figs .gc-commerce-category-section'
      )
      .forEach(
        function (section) {

          if (
            section.dataset
              .gcCategoryTabsReady ===
            'true'
          ) {
            return;
          }


          section.dataset
            .gcCategoryTabsReady =
            'true';


          section
            .querySelectorAll(
              '[data-gc-category-tab]'
            )
            .forEach(
              function (tab) {

                tab.addEventListener(
                  'click',
                  function (event) {

                    event.preventDefault();


                    activateCategoryTab(
                      section,
                      tab.getAttribute(
                        'data-gc-category-tab'
                      )
                    );

                  }
                );

              }
            );

        }
      );

  }


  /* =====================================================
     Bind carousel arrows
  ===================================================== */

  function bindGreenChefCategoryArrows() {

    document
      .querySelectorAll(
        '.greenchef-commerce-figs .gc-commerce-category-section'
      )
      .forEach(
        function (section) {

          var prev =
            section.querySelector(
              '[data-gc-category-prev], .gc-category-arrow-left'
            );


          var next =
            section.querySelector(
              '[data-gc-category-next], .gc-category-arrow-right'
            );


          if (
            !prev ||
            !next
          ) {
            return;
          }


          if (
            prev.dataset
              .gcArrowFixed !==
            'true'
          ) {

            prev.dataset
              .gcArrowFixed =
              'true';


            prev.addEventListener(
              'click',
              function (event) {

                event.preventDefault();

                event.stopPropagation();


                scrollCategory(
                  section,
                  -1
                );

              }
            );

          }


          if (
            next.dataset
              .gcArrowFixed !==
            'true'
          ) {

            next.dataset
              .gcArrowFixed =
              'true';


            next.addEventListener(
              'click',
              function (event) {

                event.preventDefault();

                event.stopPropagation();


                scrollCategory(
                  section,
                  1
                );

              }
            );

          }

        }
      );

  }


  /* =====================================================
     IMPORTANT:
     Clear pre-selected colour rings on page load
  ===================================================== */

  function resetInitialSwatchSelection(
    section
  ) {

    section
      .querySelectorAll(
        '.gc-commerce-category-swatches .gc-category-swatch'
      )
      .forEach(
        function (swatch) {

          /*
            Even if Liquid outputs "is-active",
            remove it when the category loads.

            This means the visitor sees NO
            green selection ring initially.
          */
          swatch.classList.remove(
            'is-active'
          );


          swatch.setAttribute(
            'aria-pressed',
            'false'
          );

        }
      );

  }


  /* =====================================================
     Switch image when colour is selected
  ===================================================== */

  function switchCategoryImage(
    swatch
  ) {

    if (!swatch) {
      return;
    }


    var nextImage =
      swatch.getAttribute(
        'data-gc-swatch-image'
      );


    if (!nextImage) {
      return;
    }


    var card =
      swatch.closest(
        '.gc-commerce-category-card'
      );


    if (!card) {
      return;
    }


    var image =
      card.querySelector(
        '.gc-commerce-category-img img'
      );


    if (!image) {
      return;
    }


    var group =
      swatch.closest(
        '.gc-commerce-category-swatches'
      );


    /*
      Remove active state from every
      colour in this product card first.
    */
    if (group) {

      group
        .querySelectorAll(
          '.gc-category-swatch'
        )
        .forEach(
          function (item) {

            item.classList.remove(
              'is-active'
            );


            item.setAttribute(
              'aria-pressed',
              'false'
            );

          }
        );

    }


    /*
      Green ring is added ONLY here,
      after a visitor selects a colour.
    */
    swatch.classList.add(
      'is-active'
    );


    swatch.setAttribute(
      'aria-pressed',
      'true'
    );


    /*
      Smooth image change
    */
    image.style.opacity =
      '0';


    window.setTimeout(
      function () {

        image.removeAttribute(
          'srcset'
        );


        image.setAttribute(
          'src',
          nextImage
        );


        image.onload =
          function () {

            image.style.opacity =
              '1';

          };


        /*
          Fallback in case cached images
          do not trigger onload reliably.
        */
        window.setTimeout(
          function () {

            image.style.opacity =
              '1';

          },
          220
        );

      },
      120
    );

  }


  /* =====================================================
     Bind colour swatches
  ===================================================== */

  function bindGreenChefCategorySwatches() {

    document
      .querySelectorAll(
        '.greenchef-commerce-figs .gc-commerce-category-section'
      )
      .forEach(
        function (section) {

          if (
            section.dataset
              .gcCategorySwatchesReady ===
            'true'
          ) {
            return;
          }


          section.dataset
            .gcCategorySwatchesReady =
            'true';


          /*
            IMPORTANT CHANGE:

            Remove any static / Liquid-generated
            selected swatch when page first loads.
          */
          resetInitialSwatchSelection(
            section
          );


          /*
            Mouse / touch selection
          */
          section.addEventListener(
            'click',
            function (event) {

              var swatch =
                event.target.closest(
                  '.gc-commerce-category-swatches .gc-category-swatch[data-gc-swatch-image]'
                );


              if (
                !swatch ||
                !section.contains(
                  swatch
                )
              ) {
                return;
              }


              event.preventDefault();

              event.stopPropagation();


              switchCategoryImage(
                swatch
              );

            },
            true
          );


          /*
            Keyboard selection
          */
          section.addEventListener(
            'keydown',
            function (event) {

              var swatch =
                event.target.closest(
                  '.gc-commerce-category-swatches .gc-category-swatch[data-gc-swatch-image]'
                );


              if (
                !swatch ||
                !section.contains(
                  swatch
                )
              ) {
                return;
              }


              if (
                event.key !==
                  'Enter' &&
                event.key !==
                  ' '
              ) {
                return;
              }


              event.preventDefault();

              event.stopPropagation();


              switchCategoryImage(
                swatch
              );

            },
            true
          );

        }
      );

  }


  /* =====================================================
     Initialise
  ===================================================== */

  function initGreenChefCategories() {

    bindGreenChefCategoryTabs();

    bindGreenChefCategoryArrows();

    bindGreenChefCategorySwatches();

  }


  /* =====================================================
     Standard page load
  ===================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initGreenChefCategories,
      {
        once: true
      }
    );

  } else {

    initGreenChefCategories();

  }


  /* =====================================================
     Shopify Theme Editor
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    initGreenChefCategories
  );


  /* =====================================================
     Responsive recalculation
  ===================================================== */

  window.addEventListener(
    'resize',
    function () {

      window.clearTimeout(
        window
          .__gcCategoryArrowFixTimer
      );


      window
        .__gcCategoryArrowFixTimer =
        window.setTimeout(
          initGreenChefCategories,
          120
        );

    }
  );

})();